var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.wrapper},_vm._l((_vm.facilitators),function(user,index){return _c('li',{key:index},[_c('User',{attrs:{"user":user,"size":"25px","withNameLink":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }